import { Paper, Alert, Link, Typography } from "@mui/material";
import { Attachment } from "@mui/icons-material";
import parse from "html-react-parser";

import {
  MessageDeliveryTimeline,
  MessageStatusNotice,
} from "../MessageStatus";
import {
  STATUS_ENTREGUE_APESAR_DO_ERRO,
  STATUS_SUCESSO,
  resolveStatusVisual,
} from "../../util/messageStatus";

function BodyMessage(props) {
  const stylePaper = {
    padding: 20,
  };
  const styleLink = {
    display: "flex",
    alignItems: "center"
  }

  let userCantSendFileError = false;

  let file = null;
  let displayMessage = props.row.message;
  const fileMetaTag = getSendFileMetaTag(props.row.message);
  if (props.row.userCanSendFile) {
    file = fileMetaTag;
    displayMessage = clearMetaTagMessage(wrap(props.row.message));
    if(props.row.link) {
      displayMessage = formatMessage(displayMessage, { link: props.row.link })
    }
  } else if (fileMetaTag) {
    userCantSendFileError = true;
  }

  return (
    <Paper elevation={6} style={stylePaper}>
      {userCantSendFileError && (
        <Alert severity="error">
          O seu plano não permite envio de arquivos!
        </Alert>
      )}
      {parse(displayMessage)}
      {props.row.file && props.row.file.url ? (
        <>
          <br />
          <br />
          <Paper elevation={6} style={stylePaper}>
            <Link
              target="_blank"
              href={props.row.file.url}
              underline="none"
              style={styleLink}
            >
              <Attachment />
              <span style={{ marginLeft: 5, display: "block" }}>
                {props.row.file.url.substring(
                  props.row.file.url.lastIndexOf("/") + 1
                )} {props.row.file.sizeText ? `(${props.row.file.sizeText})` : ''}
              </span>
            </Link>
          </Paper>
        </>
      ) : (
        ""
      )}
      {file && file.url ? (
        <Paper elevation={6} style={stylePaper}>
          <Link
            target="_blank"
            href={sanitizeSgpFileUrl(file.url)}
            underline="none"
            style={styleLink}
          >
            <Attachment />
            <span style={{ marginLeft: 5, display: "block" }}>
              {file.filename ? file.filename : sanitizeSgpFileUrl(file.url)} {file.sizeText ? `(${file.sizeText})` : ''}
            </span>
          </Link>
        </Paper>
      ) : (
        ""
      )}
    </Paper>
  );
}

function sanitizeSgpFileUrl(url) {
  return url.replace('/.pdf', '.pdf')
}

/**
 * Conteúdo expandido de uma mensagem no relatório.
 *
 * A decisão do que mostrar (entregue, em fila, adiada, falha) NÃO mora mais
 * aqui: vem de `resolveStatusVisual`, a mesma fonte que a tabela consulta. Isso
 * acabou com o caso em que a mensagem chegava ao destinatário mas o card exibia
 * alerta vermelho, porque cada tela lia um campo diferente do documento.
 */
function CardMessage(props) {
  const { row } = props;
  const visual = resolveStatusVisual(row);

  // A mensagem chegou a sair pelo motor de envio? Só nesses dois casos o
  // `sendAt` é a hora do envio. Em mensagem adiada pelo anti-ban o mesmo campo
  // guarda a hora FUTURA da nova tentativa — exibi-lo como "enviada em" faria o
  // relatório mentir.
  const saiuParaOWhatsapp =
    visual.chave === STATUS_SUCESSO || visual.chave === STATUS_ENTREGUE_APESAR_DO_ERRO;

  // Linha do tempo só quando o WhatsApp confirmou alguma etapa; em mensagem que
  // nem saiu da fila seria uma fileira de ícones apagados.
  const mostrarLinhaDoTempo = visual.ack > 0;

  return (
    <Paper elevation={0} sx={{ padding: 2, backgroundColor: "transparent" }}>
      <MessageStatusNotice message={row} />

      {mostrarLinhaDoTempo && <MessageDeliveryTimeline message={row} />}

      {row.sendAt && saiuParaOWhatsapp && (
        <Typography variant="caption" component="p" sx={{ mb: 1, opacity: 0.7 }}>
          <strong>Enviada em:</strong>{" "}
          {new Date(row.sendAt).toLocaleDateString("pt-br", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
          })}
        </Typography>
      )}

      <BodyMessage row={row} />
    </Paper>
  );
}

function wrap(str) {
  if (str) {
    return str
      .replace(/(?:\*)([^*]*)(?:\*)/gm, "<strong>$1</strong>")
      .replace(/(?:_)([^_]*)(?:_)/gm, "<i>$1</i>")
      .replace(/(?:~)([^~]*)(?:~)/gm, "<strike>$1</strike>")
      .replace(/(?:```)([^```]*)(?:```)/gm, "<tt>$1</tt>");
  } else {
    return str;
  }
}

function getSendFileMetaTag(message) {
  let regexSendFile = "%SendFile%(.+?)%/SendFile%";
  let regexFilename = "%Filename%(.+?)%/Filename%";
  let regexUrl = "%Url%(.+?)%/Url%";
  let regexApp = "%App%(.+?)%/App%";

  let tagSendFile = message.match(regexSendFile);
  let tagFilename;
  let tagUrl;
  let tagApp;

  let filename, app, url, type;

  if (tagSendFile) {
    tagFilename = tagSendFile[0].match(regexFilename);
    tagUrl = tagSendFile[0].match(regexUrl);
    tagApp = tagSendFile[0].match(regexApp);

    if (tagFilename) {
      filename = tagFilename[0].replace("%Filename%", "");
      filename = filename.replace("%/Filename%", "");
    }
    if (tagApp) {
      app = tagApp[0].replace("%App%", "");
      app = app.replace("%/App%", "");
    }
    if (tagUrl) {
      url = tagUrl[0].replace("%Url%", "");
      url = url.replace("%/Url%", "");

      type = url.substring(url.lastIndexOf(".") + 1);

      if ((app && app === "IXC") || (app && app === "MKAUTH")) {
        if (url.substr(-5) === ".html") {
          url = url.substring(0, url.length - 5);
        }
      }
    }
    if (url) {
      return {
        filename: filename,
        url: url,
        type: type,
        app: app,
      };
    }
  }
  return undefined;
}

function clearMetaTagMessage(message) {
  return message.replace(/(%SendFile%)(.*)(%\/SendFile%)/g, "");
}

function clearMetaTagPix(message, value = '') {
  return message.replace(/(%Pix%)((.|\r|\n|\t)*)(%\/Pix%)/g, value)
}

function clearMetaTagPaymentLink(message, value = '') {
  return message.replace(/(%PaymentLink%)((.|\r|\n|\t)*)(%\/PaymentLink%)/g, value)
}

function formatMessage(message, { link = '' } = {}) {
  let msg = clearMetaTagMessage(message)
  msg = clearMetaTagPix(msg, link)
  msg = clearMetaTagPaymentLink(msg, link)

  return msg
}

export default CardMessage;
